import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('usePrescription');

    return {
        CONNECTION_ERROR: t('connectionError'),
        FETCH_FAILED: t('fetchFailed'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
